var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPayPal = function SvgPayPal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.954 7.554h4.82c2.587 0 3.561 1.288 3.41 3.183-.247 3.124-2.169 4.852-4.717 4.852h-1.286c-.35 0-.585.228-.68.844l-.552 3.582c-.036.232-.16.37-.347.385H8.58c-.285 0-.385-.214-.31-.678l1.846-11.489c.073-.46.33-.68.84-.68l-.002.001Z",
    fill: "#009EE3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.94 3.6h4.824c1.359 0 2.971.043 4.049.978.72.626 1.098 1.62 1.01 2.688-.295 3.621-2.498 5.65-5.454 5.65h-2.38c-.406 0-.673.265-.788.98l-.664 4.152c-.044.269-.162.428-.378.448H5.188c-.33 0-.447-.249-.36-.786L6.966 4.388c.086-.535.383-.788.973-.788Z",
    fill: "#113984"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m9.272 13.477.842-5.244c.074-.46.33-.68.84-.68h4.82c.797 0 1.443.123 1.948.349-.484 3.224-2.605 5.015-5.382 5.015H9.96c-.313 0-.547.158-.688.56Z",
    fill: "#172C70"
  })));
};
export default SvgPayPal;